"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Visa = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Visa = function Visa(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.932 14.695l-4.459 10.639h-2.91L6.37 16.843c-.133-.523-.249-.714-.654-.934-.661-.36-1.754-.697-2.715-.905l.066-.31H7.75c.596 0 1.133.398 1.269 1.085l1.159 6.157 2.864-7.241h2.891zm11.4 7.165c.011-2.808-3.884-2.962-3.857-4.217.008-.382.372-.787 1.167-.892.395-.05 1.481-.09 2.715.477l.482-2.256a7.38 7.38 0 00-2.574-.472c-2.72 0-4.635 1.446-4.651 3.517-.017 1.532 1.367 2.386 2.41 2.896 1.072.52 1.432.855 1.427 1.321-.007.714-.855 1.03-1.646 1.041-1.384.022-2.187-.373-2.827-.671l-.5 2.33c.644.296 1.83.553 3.062.566 2.89 0 4.782-1.429 4.792-3.64zm7.183 3.474h2.545l-2.221-10.64h-2.35c-.528 0-.974.308-1.172.781l-4.129 9.859h2.89l.574-1.589h3.531l.332 1.589zm-3.071-3.77l1.449-3.995.834 3.995h-2.283zm-11.58-6.87l-2.275 10.64h-2.752l2.276-10.64h2.752z",
    fill: "#1A1F70"
  }));
};

exports.Visa = Visa;
var _default = Visa;
exports.default = _default;